const DEFAULT_TIMEOUT_MS = 1500;

/**
 * Resolves as soon as `document.title` equals `expectedTitle`, or after
 * `timeoutMs` at the latest. Never rejects.
 *
 * Ninetailed overwrites the `title` of a page event with `document.title` at
 * the time the event is built. After a navigation, `useHead` updates the
 * title only once the new page has rendered, which can happen after
 * `router.afterEach` — so the event would carry the previous page's title.
 *
 * @returns `true` if the title matched, `false` if the wait timed out.
 */
export function waitForDocumentTitle(
  expectedTitle: string,
  timeoutMs: number = DEFAULT_TIMEOUT_MS
): Promise<boolean> {
  if (document.title === expectedTitle) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const startedAt = performance.now();

    const check = (): void => {
      if (document.title === expectedTitle) {
        resolve(true);
      } else if (performance.now() - startedAt >= timeoutMs) {
        resolve(false);
      } else {
        setTimeout(check, 25);
      }
    };

    check();
  });
}
